
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
// npm install react-to-print

const Print_Leave_Cert = ({ lcDetails, onAfterPrint }) => {

    const printRef = useRef();

    const handlePrint = useReactToPrint({
        contentRef: printRef,
        pageStyle: `
            @page {
                size: A4;
                margin: 0;
            }

            @media print {

                body{
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }

                #lc-print{
                    width:210mm;
                    min-height:297mm;

                    padding-top:75mm;
                    padding-left:18mm;
                    padding-right:18mm;
                    padding-bottom:15mm;

                    box-sizing:border-box;

                    font-family:Arial;
                    font-size:14px;
                    line-height:1.6;
                }

                .no-print{
                    display:none;
                }
            }
        `,
        onAfterPrint: () => {
            onAfterPrint?.();
        }
    });

    // const handlePrint = useReactToPrint({
    //     contentRef: printRef,
    //     onAfterPrint
    // });

    const formatDate = (date) => {
        if (!date) return "";
        const d = new Date(date);

        return `${String(d.getDate()).padStart(2, "0")}/${String(
            d.getMonth() + 1
        ).padStart(2, "0")}/${d.getFullYear()}`;
    };

    return (

        <>
            <button
                className="btn btn-primary no-print mb-3"
                onClick={handlePrint}
            >
                Print
            </button>

            <div ref={printRef} id="lc-print">

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        rowGap: "10px",
                        columnGap: "40px"
                    }}
                >

                    <div>
                        <b>Student ID :</b> {lcDetails.student_id}
                    </div>

                    <div>
                        <b>G.R. No. :</b> {lcDetails.gr_no}
                    </div>

                    <div>
                        <b>L.C. No. :</b> {lcDetails.leave_cert_id}
                    </div>

                    <div>
                        <b>UID No. :</b> {lcDetails.aadhar_no}
                    </div>

                </div>

                <br/>

                <div>
                    <b>Name of Student :</b> {lcDetails.stud_name}
                </div>

                <br/>

                <div
                    style={{
                        display:"grid",
                        gridTemplateColumns:"1.5fr 1fr",
                        gap:"20px"
                    }}
                >

                    <div>

                        <b>Father's Name :</b> {lcDetails.father_name}

                    </div>

                    <div>

                        <b>Surname :</b> {lcDetails.father_surname}

                    </div>

                </div>

                <br/>

                <div>

                    <b>Mother's Name :</b> {lcDetails.mother_name}

                </div>

                <br/>

                <div
                    style={{
                        display:"grid",
                        gridTemplateColumns:"1fr 1fr",
                        gap:"20px"
                    }}
                >

                    <div>

                        <b>Nationality :</b> {lcDetails.nationality}

                    </div>

                    <div>

                        <b>Mother Tongue :</b> {lcDetails.mother_tongue}

                    </div>

                </div>

                <br/>

                <div
                    style={{
                        display:"grid",
                        gridTemplateColumns:"1fr 1fr 1fr",
                        gap:"20px"
                    }}
                >

                    <div>

                        <b>Religion :</b> {lcDetails.religion}

                    </div>

                    <div>

                        <b>Caste :</b> {lcDetails.caste}

                    </div>

                    <div>

                        <b>Sub Caste :</b> {lcDetails.sub_caste}

                    </div>

                </div>

                <br/>

                <div>

                    <b>Place of Birth :</b> {lcDetails.place_of_birth}

                </div>

                <br/>

                <div
                    style={{
                        display:"grid",
                        gridTemplateColumns:"1fr 1fr",
                        gap:"20px"
                    }}
                >

                    <div>

                        <b>District :</b> {lcDetails.district}

                    </div>

                    <div>

                        <b>Date of Birth :</b> {formatDate(lcDetails.date_of_birth)}

                    </div>

                </div>

                <br/>

                <div>

                    <b>Last School Attended :</b> {lcDetails.last_school}

                </div>

                <br/>

                <div
                    style={{
                        display:"grid",
                        gridTemplateColumns:"1fr 1fr",
                        gap:"20px"
                    }}
                >

                    <div>

                        <b>Admission Date :</b> {formatDate(lcDetails.adm_date)}

                    </div>

                    <div>

                        <b>Admission Std :</b> {lcDetails.std_name}

                    </div>

                </div>

                <br/>

                <div
                    style={{
                        display:"grid",
                        gridTemplateColumns:"1fr 1fr",
                        gap:"20px"
                    }}
                >

                    <div>

                        <b>Progress :</b> {lcDetails.progress}

                    </div>

                    <div>

                        <b>Conduct :</b> {lcDetails.conduct}

                    </div>

                </div>

                <br/>

                <div>

                    <b>Date of Leaving :</b> {formatDate(lcDetails.leave_cert_date)}

                </div>

                <br/>

                <div>

                    <b>Studying Since :</b> {lcDetails.std_studying_since}

                </div>

                <br/>

                <div>

                    <b>Reason For Leaving :</b> {lcDetails.leave_reason}

                </div>

                <br/>

                <div>

                    <b>Remarks :</b> {lcDetails.remarks}

                </div>

                <br/><br/>

                <div
                    style={{
                        textAlign:"center",
                        fontWeight:"bold",
                        marginTop:"20px"
                    }}
                >
                    CERTIFIED THAT THE ABOVE INFORMATION IS IN ACCORDANCE
                    WITH THE SCHOOL REGISTER.
                </div>

                <br/><br/><br/>

                <div
                    style={{
                        display:"flex",
                        justifyContent:"space-between"
                    }}
                >

                    <div>

                        Date : {formatDate(new Date())}

                    </div>

                    <div>

                        Class Teacher

                    </div>

                    <div>

                        Principal

                    </div>

                </div>

            </div>

        </>
    );

};

export default Print_Leave_Cert;
